export function mapUserFromApi(data, options = {}) {
  const { includePassword = false, verified = '' } = options;

  const user = {
    id: data.id,
    displayName: `${data.firstName} ${data.lastName}`,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    photoURL: data.photoURL || '',
    about: '',
    address: data.address,
    city: '',
    country: '',
    isPublic: true,
    phoneNumber: data.phone,
    role: data.role,
    state: '',
    status: '',
    zipCode: '',
    profile_completed: '',
    updated_at: data.updatedAt,
    verified,
    email_verified: '',
    birthday: '',
    created_at: data.createdAt,
  };

  if (includePassword) {
    user.password = data.password;
  }

  return user;
}